module.exports = "<div class=\"app-body\" (window:resize)=\"onResize()\">\r\n    <router-outlet></router-outlet>\r\n</div>"